export const GET_MENSAJERIA = 'GET_MENSAJERIA'
export const SET_MENSAJERIA = 'SET_MENSAJERIA'
